import styled from 'styled-components';
import { Row } from 'antd';
import { media, vars } from '$util/theme';
import { getBreakpoint } from '$util/theme/breakpoints';
import VrmLookup from '$quantum/molecules/VrmLookup';
import { Title } from '@/components/atoms/Title';

export const StyledRow = styled(Row)`
  z-index: 10;
  p {
    white-space: break-spaces;
    margin-bottom: 1.3rem;
  }
`;

export const BackgroundContainer = styled.div`
  padding: 30px 20px;
  color: ${vars.quantumverse.reskinColors.white};
  background: #314153;
  position: relative;
  &.rounded {
    border-radius: 4px;
    overflow: hidden;
  }
`;

export const BgImage = styled.div`
  background-size: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
`;

export const LimitWidthOverlay = styled.div`
  background: rgba(50, 68, 85, 0.65);
  z-index: 2;
  opacity: 0.5;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
`;

export const BgVideo = styled.iframe`
  width: 100vw;
  height: 56.25vw; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100vh;
  min-width: 177.77vh; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const VideoWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
  overflow: hidden;
`;

export const WidgetContainer = styled.div`
  max-width: 982px;
  margin: auto;
  padding: 10px 0 30px;
  color: #e4e4e4;
  z-index: 3;
  position: relative;
  @media (max-width: ${getBreakpoint('sm')}) {
    padding: 0;
  }
`;

export const ShapeOverlay = styled.div`
  height: 100%;
  width: 62%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  opacity: 0.8;
  @media (min-width: ${getBreakpoint('sm')}) {
    background: url('https://res.cloudinary.com/fxtr/image/upload/v1624441860/landing/widgets/widget_banner_shape_d5ekmy.svg')
      no-repeat;
    background-size: cover;
    background-position: right;
  }
  @media (min-width: ${getBreakpoint('md')}) and (max-width: 1000px) {
    width: 68% !important;
  }
`;

export const StyledTitle = styled(Title)`
  color: white;
  font-size: 2rem;
  font-weight: 500;
  ${media.up('md')} {
    font-size: 3rem;
  }
`;

export const StyledVrmLookup = styled(VrmLookup)`
  background: transparent !important;
  box-shadow: 0 !important;
  padding: 0;
  max-width: 100% !important;
  ${media.up('md')} {
    max-width: 82% !important;
  }
  &.limited-width {
    max-width: 100% !important;
  }
  .input-group {
    display: flex;
    flex-direction: column;
    .FormItem {
      &.postcode {
        ${media.only('md')} {
          margin-right: 10px;
        }
        ${media.up('md')} {
          margin-bottom: 10px;
        }
      }
      ${media.up('md')} {
        width: 50% !important;
        input {
          min-width: unset;
        }
      }
    }
    ${media.up('md')} {
      flex-direction: row;
      align-items: center;
    }
  }

  .footer-group .-submit {
    margin-bottom: 0 !important;
  }

  li {
    color: ${vars.quantumverse.reskinColors.neutral800};
  }
`;
